import type { StepLabelProps as SharedStepLabelProps } from '@packages/shared';
import { StepLabel as SharedStepLabel, stepLabelClasses } from '@packages/shared';
import { gapBetweenIconAndText } from '../config';

export type StepLabelProps = SharedStepLabelProps;

export const StepLabel = ({ sx, ...rest }: StepLabelProps) => (
  <SharedStepLabel
    {...rest}
    sx={{
      ...sx,

      [`& .${stepLabelClasses.iconContainer}`]: {
        mr: [0, 0, `${gapBetweenIconAndText}rem`],
        p: 0,
      },
    }}
  />
);
